module.exports = __webpack_public_path__ + "img/emoji.f0509584.png";